import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeComplianceException } from '../api/compliance.js';

/** Removing a decision, used from a check's row and from the exceptions list. */
export function useRemoveDecision(): { remove: (id: string) => void; pending: boolean } {
  const queryClient = useQueryClient();
  const removal = useMutation({
    mutationFn: removeComplianceException,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['compliance'] });
      void queryClient.invalidateQueries({ queryKey: ['compliance-checks'] });
      void queryClient.invalidateQueries({ queryKey: ['compliance-exceptions'] });
      void queryClient.invalidateQueries({ queryKey: ['hardening'] });
    },
  });
  return { remove: removal.mutate, pending: removal.isPending };
}
